var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85022 8.51349L11.8814 1.44485C12.022 1.23588 11.9985 0.976397 11.9985 0.780422C11.9985 -0.00347724 11.3148 2.77118e-07 11.1416 2.79184e-07L0.858416 4.0181e-07C0.711978 4.03556e-07 0.00144768 -0.00343136 0.00144769 0.780422C0.00144769 0.976397 -0.0218649 1.23593 0.118629 1.44485L5.14977 8.51344C5.53977 9.09363 6.00002 8.99338 6.00002 8.99338C6.00002 8.99338 6.46027 9.09368 6.85022 8.51349Z",
    fill: "#D9685B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeVector);
export default __webpack_public_path__ + "static/media/orangeVector.da0448676fdaf4ac1f85d53c3682ec51.svg";
export { ForwardRef as ReactComponent };